var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2916 6.50002H15.7083C16.3074 6.50002 16.7916 6.98427 16.7916 7.58335C16.7916 8.18244 16.3074 8.66669 15.7083 8.66669H10.2916C9.69256 8.66669 9.20831 8.18244 9.20831 7.58335C9.20831 6.98427 9.69256 6.50002 10.2916 6.50002ZM11.375 17.875C11.375 16.978 12.103 16.25 13 16.25C13.897 16.25 14.625 16.978 14.625 17.875C14.625 18.772 13.897 19.5 13 19.5C12.103 19.5 11.375 18.772 11.375 17.875ZM19.5 20.5834C19.5 21.1814 19.0146 21.6667 18.4166 21.6667H7.58331C6.98531 21.6667 6.49998 21.1814 6.49998 20.5834V5.41669C6.49998 4.81869 6.98531 4.33335 7.58331 4.33335H18.4166C19.0146 4.33335 19.5 4.81869 19.5 5.41669V20.5834ZM18.4166 2.16669H7.58331C5.79148 2.16669 4.33331 3.62485 4.33331 5.41669V20.5834C4.33331 22.3752 5.79148 23.8334 7.58331 23.8334H18.4166C20.2085 23.8334 21.6666 22.3752 21.6666 20.5834V5.41669C21.6666 3.62485 20.2085 2.16669 18.4166 2.16669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.af121ccda97627d7e46b4f417485d8cc.svg";
export { ForwardRef as ReactComponent };